import React, { useEffect, useState } from 'react'
import { useCreateRepairOrderMutation, useGetRepairDetailsQuery } from '../../../Services/inventory/Inventory'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../components/LoadingSpinner'
import EmptyRows from '../../../components/reusableComponent/EmptyRows'
import useThemeColors from '../../vehicle/ThemeColors'
import { Loader } from 'react-bootstrap-typeahead'

const RepairOrderManagement = () => {

    const [repairOrder, setRepairOrder] = useState<any>({
        name: "",
        vehicle_details: "",
        repair_description: "",
        status: "pending"

    })

    const [getRepairOrderData, setGetRepairOrderData] = useState([])

        const [tableLoader, setTableLoader] = useState(false)
        const [loading, setLoading] = useState(false)

    
    const [repairOrderTrigger, {status: repairOrderStatus}] = useCreateRepairOrderMutation()
   const {data: getRepairDetail, isLoading, status, refetch} =  useGetRepairDetailsQuery({})
//    const {repairOrderData, refetch, status, isLoading} = useGetRepairDetailsQuery({})

useEffect(() => {
    if (repairOrderStatus === "pending") {
        setLoading(true)

    }
    else {
        setLoading(false)
    }

}, [repairOrderStatus])

    const repairOrderHeader = [
        {label: "Id", key: "id"},

        {label: "Order number", key: "order_numb"},
        {label: "Customer", key: "customer"},
        {label: "Vehicle", key: "vehicle"},
        {label: "Status", key: "Status"},

    ]

    console.log(status, "tableLoader")
        useEffect(() => {
          if (status === "pending") {
            setTableLoader(true)
          }
          else {
            setTableLoader(false)
          }
      
        }, [status])
      

    useEffect(() => {
        if (getRepairDetail) {
            setGetRepairOrderData(getRepairDetail?.results)

        }

    }, [getRepairDetail])


const customerNameHandler = (e) => {
    setRepairOrder(prev => ({...prev, name: e.target.value}))
}

const vehicleDetailHandler = (e) => {
    setRepairOrder(prev => ({...prev, vehicle_details: e.target.value}))
}
const repairDescriptionHandler = (e) => {
    setRepairOrder(prev => ({...prev, repair_description: e.target.value}))
}


    const createRepairOrderhandler = async(e) => {
        e.preventDefault()
        //  const repairOderObj = {
        //     repairOrder
        //  }

  

         const response = await repairOrderTrigger(repairOrder)
         console.log(response, "responbsne")

         try {
            if (response?.data) {
                toast.success("Repair order added successfully")
                refetch()
                setRepairOrder({
                    // merge: false,
                      name: "",
                      vehicle_details: "",
                      repair_description: "",
                      status: ""
                  })
                  


            }
            
         } catch (error) {
            
         }

    }
         const {
              selectedColor,
              selectedBackgroundColor,
              selectedBorderColor,
              selectedButtonBackgoundColors,
              selectedButtonColors,
          } = useThemeColors();
  

  return (
              <div className="vehicle-info-cont">

    <div id="kt_app_content_container" className="app-container mx-5">
        {/* <div className="card card-flush"> */}
        {/* <div
                style={{
                    // marginBottom: "30px",
                    display: "flex",
                    width: "100%",
                    gap: "20px",
                    padding: "20px"
                }}
            >
                <div className="col">
                    <span className="input-group-text" id="basic-addon1">
                        Repair order management
                    </span>
                </div>

             
            </div> */}


            {/* <div style={{display: "flex", flexDirection: "column", padding: "20px", gap: "20px", paddingTop:"0"}}> */}
              <div
                className="vehicle-info-middle"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px`, marginBottom: "20px" }}
            >

                <div className="vehicle-info-middle-heading">Create new repair order</div>
                <div style={{display: "flex", gap: "10px", justifyContent: "space-between", marginBottom: "10px", padding: "10px 20px"}}>

                <div style={{display: "flex", flexDirection: "column", width: "100%"}}><label>Customer name</label><input style={{borderRadius: "20px"}} onChange={customerNameHandler}  value={repairOrder?.name} placeholder='Customer name...'  className='form-control'/></div>
                <div style={{display: "flex", flexDirection: "column", width: "100%"}}><label>Vehicle details</label><input style={{borderRadius: "20px"}} onChange={vehicleDetailHandler} value={repairOrder?.vehicle_details} placeholder='Vehicle details...'  className='form-control'/></div>
                <div style={{display: "flex", flexDirection: "column", width: "100%"}}><label>Repair description</label><input style={{borderRadius: "20px"}} onChange={repairDescriptionHandler} value={repairOrder?.repair_description} placeholder='Repair description...' className='form-control'/></div>
                </div>
                <div style={{display: "flex", justifyContent: "end", width: "100%", padding: "10px 20px"}}>
                    <button     style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                            }}  onClick={createRepairOrderhandler}>{loading ? <>Creating...<Loader /></> : "Create Repair order"}</button></div>
            </div>

            {/* </div> */}
            {/* Repair order list */}
            <div   className="vehicle-info-bottom"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}>
                {/* Header */}
                {/* <div className="col"> */}
                    <div
                        className="card p-4"
                        style={{ backgroundColor: "rgb(247, 211, 197)" ,
                        }}
                    >
                <div className="row align-items-center">
                            {repairOrderHeader?.map((repair, index) => (
                                <div className="col" key={index}>
                                    <label htmlFor="">
                                        <strong
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                            }}
                                        >
                                            {repair?.label}
                                     
                                        </strong>
                                    </label>
                                </div>
                            ))}
                         
                        </div>
                        </div>
                        {/* </div> */}





            </div>

              <div className="row" style={{ height: "60vh", overflow: "scroll" , padding: "0 10px"}}>
                                    {isLoading || tableLoader ? (
                                                <LoadingSpinner />
                                            ) : (
                                        <>
                                        {!getRepairOrderData?.length ? <EmptyRows value={''}/> : 
                                        <div className="col" style={{ paddingRight: "0px" }}>
                                           
                                                <>
                                                    {getRepairOrderData?.length ? (
                                                        <>
                                                            {getRepairOrderData?.map(
                                                                (inventory: any, index: any) => (
                                                                    <div
                                                                        className="card mt-2 my-1 p-4"
                                                                        key={index}
                                                                        style={{
                                                                            background: index % 2 !== 0 ? "#FFF1EC" : "white"

                                                                        }}
                                                                    >
                                                                        <div className="row align-items-start">
                                                                            <div className="col text-start">
                                                                                <label
                                                                                    htmlFor=""
                                                                                    style={{
                                                                                        paddingLeft:
                                                                                            "10px",
                                                                                    }}
                                                                                >
                                                                                    {/* {index + 1} */}
                                                                                    {inventory?.id}
                                                                                </label>
                                                                            </div>
                        
                                                                            <div className="col text-start">
                                                                                <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                                    {
                                                                                        inventory?.name
                                                                                    }
                                                                                </label>
                                                                            </div>
            
            
                                                                            <div className="col text-start">
                                                                                <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                                    {
                                                                                        inventory?.vehicle_details
                                                                                    }
                                                                                </label>
                                                                            </div>
                        
                                                                            <div className="col text-start">
                                                                                <label htmlFor="" style={{paddingLeft: "15px"}}>
                                                                                    {inventory?.repair_description}
                                                                                </label>
                                                                            </div>
                                                                            <div className="col text-start">
                                                                                <label htmlFor="" style={{paddingLeft: "15px"}}>
                                                                                    {inventory?.status}
                                                                                </label>
                                                                            </div>
                        
                                                                            {/* <div className="col text-start">
                                                                                <label htmlFor="" style={{paddingLeft: "18px"}}>
                                                                                    {inventory?.price_per_unit}
                                                                                </label>
                                                                            </div> */}
                        
                                                                  
                        
                                                                            {/* <div
                                                                                className="col text-center d-flex"
                                                                                style={{
                                                                                    gap: "10px",
                                                                                    justifyContent:
                                                                                        "end",
                                                                                    paddingRight:
                                                                                        "25px",
                                                                                }}
                                                                            >
                                                                                <button
                                                                                    className="text-hover-primary border-0 bg-white me-2"
                                                                                    title="Edit"
                                                                                    onClick={() =>
                                                                                        EditModal(
                                                                                          inventory.id
                                                                                        )
                                                                                    }
                                                                                    onClick={() => isEditModal(inventory)}
                                                                                >
                                                                                    <i className="bi bi-pencil text-dark fs-4"></i>
                                                                                </button>
                                                                                <button
                                                                                    className="text-hover-danger border-0 bg-white me-2"
                                                                                    title="Delete"
                                                                                    onClick={() =>
                                                                                        isDeleteModal(
                                                                                          inventory
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <i className="bi bi-trash text-dark fs-4"></i>
                                                                                </button>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </>
                                                    ) : (
                                                        ""
                                                        // <EmptyRows value={""} />
                                                    )}
                                                </>
                                        </div>
                        }
                        </>
                                            )}
                        
                                    </div>


            {/* </div> */}
            </div>

    </div>
  )
}

export default RepairOrderManagement